import { IModel, Model } from "./Model";

export interface IPrognosisScoreModel extends IModel {
    prognosisScoreId: number;
    name: string;
    description: string;
}

export class PrognosisScoreModel extends Model implements Record<keyof IPrognosisScoreModel, any> {
    prognosisScoreId: number
    name: string
    description: string
    constructor(params: Partial<IPrognosisScoreModel> = {}) {
        super(params);
        this.prognosisScoreId = params.prognosisScoreId ?? 0;
        this.name = params.name ?? "";
        this.description = params.description ?? "";
    }
}
